// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3c965","alertIcon":"ConfirmModal_alertIcon__3Vzu9"};